import React from 'react';

import {connect} from '@stubhub/react-store-provider';

// Controller
import controller from './controller';

function withNoListingsData(InnerComp) {
  @connect(controller)
  class NoListingsProvider extends React.Component {
    render() {
      return <InnerComp {...this.props} />;
    }
  }

  return NoListingsProvider;
}

export default withNoListingsData;
